import { render, staticRenderFns } from "./detailYuyue.vue?vue&type=template&id=512d0ba8&scoped=true&"
import script from "./detailYuyue.vue?vue&type=script&lang=js&"
export * from "./detailYuyue.vue?vue&type=script&lang=js&"
import style0 from "./detailYuyue.vue?vue&type=style&index=0&id=512d0ba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512d0ba8",
  null
  
)

export default component.exports